export function getLosRestriction(rate) {
  let los = null;
  if (rate && rate.message.indexOf('rates.restriction') === 0) {
    los = rate.message[rate.message.length - 1];
  }

  return los;
}

export function checkLosRestriction(rate) {
  return rate?.ota === 'bookingdotcom' && getLosRestriction(rate);
}
